<ng-container *ngIf="dataSource$ | async as fieldHandlers">
  <mat-card appearance="outlined" *ngIf="(loadingStatus$ | async) === LoadingStatus.OK" style="padding: 0">
    <table mat-table class="attribute-table" content [dataSource]="fieldHandlers" [trackBy]="trackByFn">
      <ng-container [matColumnDef]="Columns.Name">
        <mat-header-cell *matHeaderCellDef class="name-column">
          {{ 'AUXILIARY_DATA_TABLE.ATTRIBUTE_COLUMN' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let handler" class="name-column">
          {{ handler.name }}
          <mat-icon
            #tooltip="matTooltip"
            *ngIf="handler.description"
            [matTooltip]="handler.description"
            (click)="tooltip.toggle()"
          >
            info_outline
          </mat-icon>
        </mat-cell>
      </ng-container>
      <ng-container [matColumnDef]="Columns.Value">
        <mat-header-cell *matHeaderCellDef class="value-column">
          {{ 'AUXILIARY_DATA_TABLE.DATA_COLUMN' | translate }}
        </mat-header-cell>
        <mat-cell *matCellDef="let handler" class="value-column">
          <aux-renderer-selector [handler]="handler"></aux-renderer-selector>
        </mat-cell>
      </ng-container>
      <ng-container [matColumnDef]="Columns.Action">
        <mat-header-cell *matHeaderCellDef class="action-column">
          <a
            data-action="clicked-manage-custom-fields-data-table"
            mat-stroked-button
            [href]="auxiliaryDataAdminURL"
            *ngIf="!disableManage && auxiliaryDataAdminURL"
          >
            {{ 'COMMON.MANAGE_ATTRIBUTES' | translate }}
          </a>
        </mat-header-cell>
        <mat-cell *matCellDef="let handler" class="action-column"></mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns" style="width: 100%"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns" style="width: 100%"></mat-row>
    </table>
  </mat-card>
</ng-container>
<ng-container *ngIf="(loadingStatus$ | async) === LoadingStatus.LOADING">
  <div class="loading-container">
    <mat-spinner diameter="24" strokeWidth="2"></mat-spinner>
  </div>
</ng-container>
<glxy-empty-state *ngIf="(loadingStatus$ | async) === LoadingStatus.EMPTY">
  <glxy-empty-state-hero>
    <mat-icon class="empty-state-icon">topic</mat-icon>
  </glxy-empty-state-hero>
  <glxy-empty-state-title>
    {{ 'AUXILIARY_DATA_TABLE.EMPTY.TITLE' | translate }}
  </glxy-empty-state-title>
  <p>{{ 'AUXILIARY_DATA_TABLE.EMPTY.TEXT' | translate }}</p>
  <glxy-empty-state-actions>
    <a
      data-action="clicked-manage-custom-fields-empty-table"
      mat-stroked-button
      [href]="auxiliaryDataAdminURL"
      *ngIf="auxiliaryDataAdminURL"
    >
      {{ 'AUXILIARY_DATA_TABLE.EMPTY.BUTTON' | translate }}
    </a>
  </glxy-empty-state-actions>
</glxy-empty-state>
<glxy-empty-state *ngIf="(loadingStatus$ | async) === LoadingStatus.ERROR">
  <glxy-empty-state-hero>
    <mat-icon>report_problem</mat-icon>
  </glxy-empty-state-hero>
  <glxy-empty-state-title>
    {{ 'AUXILIARY_DATA_TABLE.ERROR.TITLE' | translate }}
  </glxy-empty-state-title>
  <p>{{ 'AUXILIARY_DATA_TABLE.ERROR.TEXT' | translate }}</p>
  <glxy-empty-state-actions></glxy-empty-state-actions>
</glxy-empty-state>
